import { useQuery } from "react-query";
import api from "../services/apiService";
import ApiRoutes from "../services/apiRoutes";

import { DashboardResponse } from "../models/dashboard/dashboardResponse";

export const useDashBoardQuery = () => {
  return useQuery<DashboardResponse>(
    "useDashBoard",
    () => api.get(ApiRoutes.getDashBoard),
    {}
  );
};
